export default "__VITE_PUBLIC_ASSET__b0c26b39__"